<template lang="html">
  <div>
    <MonacoEditor v-model="node.code" language="javascript" class="code_editor" disabledminimap />
    <div>
      <div class="node-choice">
        <label style="width: 100%;background: none;">Continue</label>
        <div class="node-connector" :class="{'active': node.to}" :data-to="node.to"></div>
      </div>
    </div>
  </div>
</template>

<script>
import MonacoEditor from '@/assets/components/code/MonacoEditor.vue';

export default {
	props: ['node'],
  components: {
    MonacoEditor
  }
}
</script>

<style lang="css" scoped>
.code_editor {
  padding: 0;
  min-height: 120px;
}
.node-choice {
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}
.node-choice .node-connector {
  margin-left: 2px;
  margin-right: -9px;
  border-radius: 50%;
  border: 3px solid #34434b;
  width: 18px;
  height: 18px;
  flex: 0 0 auto;
  background-color: #1f282d;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  /* border-left-color: transparent; */
  /* border-top-color: transparent; */
  transform: rotate(-45deg);
}
.node-choice .node-connector.active::before {
  content: '';
  position: absolute;
  background-color: #ffa800;
  border-radius: 50%;
  inset: 1px;
}
.node-box.selected .node-choice .node-connector {
  border-right-color: rgba(255, 168, 0, 0.8);
  border-bottom-color: rgba(255, 168, 0, 0.8);
}
</style>
